import { render, staticRenderFns } from "./ThankYouPopup.vue?vue&type=template&id=45e515c1"
import script from "./ThankYouPopup.vue?vue&type=script&lang=js"
export * from "./ThankYouPopup.vue?vue&type=script&lang=js"
import style0 from "./ThankYouPopup.vue?vue&type=style&index=0&id=45e515c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports